import { useState, useCallback } from 'react'
import { graphqlFetch } from '@pylot/graphqlFetch'
import { StoreStockInput } from '@pylot/pylotschema'

export const useStoreStock = () => {
    const [storeStockItems, setStoreStockItems] = useState([])
    const [emptyStoreStock, setEmptyStoreStock] = useState(false)
    const [defaultStoreRegion, setDefaultStoreRegion] = useState('default')

    const handleStock = useCallback(async (value: string, sku: string) => {
        const regionValue = value.length <= 1 ? `0${value}` : value
        setDefaultStoreRegion(value)
        setEmptyStoreStock(false)

        try {
            const response = await graphqlFetch<StoreStockInput, any>({
                query: `
                query storeStock($input: StoreStockInput!) {
                    storeStock(input: $input) {
                        localId
                        nombreLocal
                        region
                        ciudad
                        comuna
                        codBodega
                        nombreBodega
                        sku
                        stock
                    }
                }
                `,
                variables: {
                    input: {
                        regionId: regionValue,
                        sku: sku
                    }
                },
                customPylotQueryHeader: 'config'
            })

            if (response?.data?.storeStock) {
                setStoreStockItems(response.data.storeStock)
                setEmptyStoreStock(response.data.storeStock.length === 0)
            }
        } catch (error) {
            console.error('Store stock fetch error:', error)
            setEmptyStoreStock(true)
        }
    }, [])

    return {
        storeStockItems,
        emptyStoreStock,
        defaultStoreRegion,
        handleStock
    }
}
